//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/solucoes/:solution/:application',
      en: '/solutions/:solution/:application',
      es: '/soluciones/:solution/:application'
    }
  },

  async asyncData({ $api, params, $helpers }) {
    try {
      // Get application details
      const { application: slug } = params
      const { data } = await $api.solutions.application(slug)
      const { application, related_products, related_applications } = data

      // Handle with the medias
      if (application.video) {
        const video = {
          url: $helpers.getYTThumbnail(application.video),
          video_url: application.video,
          type: 'video',
          custom: {}
        }

        application.medias = [video, ...application.medias]
      }

      return {
        application,
        related_products,
        related_applications
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      application: {},
      related_products: [],
      related_applications: []
    }
  },

  head() {
    const { title, seo, main_image } = this.application

    return this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('title'),
      staticDescription: seo ? seo.description : null,
      ogImage: main_image ? main_image.url : null,
      ogImageWidth: main_image ? 645 : null,
      ogImageHeight: main_image ? 359 : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('solution'),
          path: '/solucoes'
        }
      ]

      if (this.application.solution) {
        breadcrumbs.push({
          name: this.application.solution.title,
          path: `/solucoes/${this.application.solution.slug}`
        })
      }

      breadcrumbs.push({
        name: this.application.title,
        path: this.$route.fullPath
      })

      return breadcrumbs
    }
  }
}
